import {useNavigate, useParams} from "react-router";
import React, {useContext, useEffect} from "react";
import {SoknaderContext} from "./contexts/SoknaderContext";
import {Button, Container, Form} from "react-bootstrap";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faArrowLeft, faEnvelope, faTrash} from "@fortawesome/free-solid-svg-icons";
import PersonaliaCard from "./PersonaliaCard";
import SoknadCard from "./SoknadCard";
import ArbeidsforholdCard from "./ArbeidsforholdCard";
import VedleggCard from "./VedleggCard";
import SoknadNotes from "./SoknadNotes";


function SoknadView() {

    const {id} = useParams();
    const {
        getSoknadById,
        soknad,
        trekkSoknad
    } = useContext(SoknaderContext);
    const navigate = useNavigate();
    const readOnly=true;


    useEffect(() => {
        getSoknadById(Number(id));
    }, [])

    if (!soknad) {
        return (<>
            <div>Henter søknad...</div>
        </>);
    }
    return (<>
        <h3>
            Søknad nr {soknad.id}
        </h3>
        <h4>Status: {soknad.status?.name??"Ny"}</h4>
        <hr/>
        <Button className={"m-2"} disabled={!soknad} onClick={() => navigate("/soknader")}><FontAwesomeIcon
            icon={faArrowLeft}></FontAwesomeIcon> Tilbake</Button>
        {
            soknad.id!==0?
                <>
                    {
                        soknad.statusId!==8?
                            <Button className={"m-2 btn-secondary"} disabled={!soknad} onClick={trekkSoknad}><FontAwesomeIcon
                        icon={faTrash}></FontAwesomeIcon> Trekk søknaden</Button>
                            :null
                    }
                </>
                :null
        }
        <hr/>

        <Container>
            <Form>
                <div className="p-1">
                    <SoknadNotes></SoknadNotes>
                </div>
                <div className="p-1">
                    <PersonaliaCard readOnly={readOnly} ></PersonaliaCard>
                </div>
                <div className="p-1">
                    <SoknadCard readOnly={readOnly} ></SoknadCard>
                </div>

                <div className="p-1">
                    <ArbeidsforholdCard readOnly={readOnly} ></ArbeidsforholdCard>
                </div>
                <div className="p-1">
                    <VedleggCard readOnly={readOnly} ></VedleggCard>
                </div>
            </Form>
        </Container>
    </>);
}

export default SoknadView;